/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
class r{constructor(r,s,t){this.graphic=r,this.renderingInfo=s,this.layer=t}}export{r as Graphics3DGraphicCreationContext};
